import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ButtonPrimaryMedium } from "../../generic/common/ButtonPrimaryMedium";
import { TextLoca } from "../../generic/text/TextLoca";
export var ButtonPlaceBuilding = function (_a) {
    var onPlace = _a.onPlace, buildingInfo = _a.buildingInfo;
    return (React.createElement("div", { className: "button-ribbon" },
        React.createElement(ButtonPrimaryMedium, { onClick: function () { return onPlace(buildingInfo); } },
            React.createElement("div", { className: "flex flex--guts" },
                React.createElement("div", { className: IdStyles.TextButtonHeading },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.place }))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/ButtonPlaceBuilding.tsx
// module id = 2740
// module chunks = 3